import { render, staticRenderFns } from "./WaybillTypeIndex.vue?vue&type=template&id=274e2748&scoped=true&"
import script from "./WaybillTypeIndex.vue?vue&type=script&lang=js&"
export * from "./WaybillTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e2748",
  null
  
)

export default component.exports